import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import FeatherIcon from 'feather-icons-react';
import moment from 'moment';
import { Link } from 'react-router-dom';

export const tableColumns: ColumnDef<any>[] = [
  {
    accessorKey: 'points',
    header: 'Points',
    cell: ({ row: { original } }) => {
      const { points } = original;
      return <>{points}</>;
    },
    meta: {
      headerProps: { className: 'pe-3' }
    }
  },
  {
    accessorKey: 'tokens',
    header: 'Tokens',
    meta: {
      headerProps: {},
      cellProps: { className: 'text-body fs-9' }
    }
  },
  {
    accessorKey: 'burn_tokens',
    header: 'Burn Tokens',
    cell: ({ row: { original } }) => {
      const { burn_tokens } = original;
      return <span className="fw-semibold">{burn_tokens}</span>;
    },
    meta: {
      headerProps: { className: 'pe-3' }
    }
  },
  {
    accessorKey: 'pointsType',
    header: 'Points Type',
    cell: ({ row: { original } }) => {
      const { pointsType } = original;
      return <span className="fw-semibold">{pointsType}</span>;
    },
    meta: {
      headerProps: { className: 'pe-3' }
    }
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row: { original } }) => {
      const { status } = original;
      return <span className="fw-semibold">{status}</span>;
    },
    meta: {
      headerProps: { className: 'pe-3' }
    }
  },
  {
    accessorKey: 'createdAt',
    header: 'Created At',
    cell: ({ row: { original } }) => {
      const { createdAt } = original;
      return (
        <span className="fw-semibold">
          {moment(createdAt).format('MM-DD-YYYY h:mm A')}
        </span>
      );
    },
    meta: {
      headerProps: { className: 'pe-3' }
    }
  }
];

const UserRewardClaimTable = () => {
  return (
    <div className="border-y border-translucent">
      <AdvanceTable tableProps={{ className: 'phoenix-table table-sm fs-9' }} />
      <AdvanceTableFooter pagination showViewAllBtn={false} />
    </div>
  );
};

export default UserRewardClaimTable;
